import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; 
import "./Incubation.css";
import {
  Backtotop,
  Floatinmenu,
  Underline,
  ToolCard,
} from "../../widgets";

import { RadialMenu, Heroimagecarousal } from "../../components";
import { incubation_img_corousal } from "../../constants/incubation";

import { FaComputer } from "react-icons/fa6";

import {
  facilities_available,
  operating_system_menu
} from "../../constants/incubation";

const Incubation_Facilities = () => {
  const location = useLocation(); // get current URL

  useEffect(() => {
    document.title = "Incubation Facilities";
  }, []);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = location.hash;
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }, 50); // wait for React to render
      }
    };

    scrollToHash(); // run on initial load or location change
  }, [location]); // run every time URL or hash changes

  return (
    <div className="incubationdept">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />
      <section className="incubation_fac">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={operating_system_menu} />
        </div>
        <RadialMenu menu_links={operating_system_menu} />
        <div className="incubation_support_services_container">
          <div className="incubation_support_services">
            <Underline heading="Facilities Available" />
            {facilities_available.map((tool) => (
              <div id={`facility-${tool.id}`} key={tool.id}>
                <ToolCard tool={tool} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <Backtotop />
    </div>
  );
};

export default Incubation_Facilities;
